import script from "./blend-constituent-item.vue?vue&type=script&setup=true&lang=js"
export * from "./blend-constituent-item.vue?vue&type=script&setup=true&lang=js"

import "./blend-constituent-item.vue?vue&type=style&index=0&id=3735595a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3735595a"]])

export default __exports__